import { render, staticRenderFns } from "./MediaGalleryInput.vue?vue&type=template&id=0beba4d3&scoped=true&lang=pug&"
import script from "./MediaGalleryInput.vue?vue&type=script&setup=true&lang=js&"
export * from "./MediaGalleryInput.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MediaGalleryInput.vue?vue&type=style&index=0&id=0beba4d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beba4d3",
  null
  
)

export default component.exports